export const v2Keys = {
  assets: {
    all: ["v2", "assets"] as const,
    list: () => [...v2Keys.assets.all, "list"] as const,
    available: (startDate: string, endDate: string, type?: string) =>
      [...v2Keys.assets.all, "available", startDate, endDate, type ?? "all"] as const,
  },
  requests: {
    all: ["v2", "requests"] as const,
    list: () => [...v2Keys.requests.all, "list"] as const,
    byRequester: (requesterId: string) =>
      [...v2Keys.requests.all, "byRequester", requesterId] as const,
    detail: (id: string) => [...v2Keys.requests.all, "detail", id] as const,
    // Dossier valt onder de requests-key zodat het mee invalideert.
    dossier: (dossierId: string) => [...v2Keys.requests.all, "dossier", dossierId] as const,
  },
} as const;
